<template>
  <div class="d-flex justify-end my-4 mr-6">
    <v-btn
      color="primary"
      class="mb-2 rounded-pill elevation-0"
      @click="$emit('addItem')"
      :disabled="loading"
    >
      Add NNS
    </v-btn>

    <v-btn
      icon
      color="warning"
      class="mb-2 ml-2"
      @click="$emit('getData')"
      :loading="loading"
      :disabled="loading"
    >
      <v-icon>mdi-refresh</v-icon>
    </v-btn>

  </div>
</template>

<script>
export default {
  props: {
    loading: Boolean,
  }
};
</script>
